import { useLiveData } from "./LiveDataProvider";
import Outlet from "../router/Outlet";
import LeftSidebar from "../common/left-sidebar/LeftSidebar";
import SidebarLink from "../common/left-sidebar/SidebarLink";
import CollapseMenu from "../common/menu/CollapseMenu";
import RightSidebar from "../common/right-sidebar/RightSidebar";
import Menu from "../prematch/Menu";
import { ErrorBoundary } from "../common/ErrorBoundary";
import ErrorMessageWithLink from "../common/ErrorMessageWithLink";
import { livePrefix, prematchPrefix } from "../Container";
import { getLabel } from "../InitData";
import LiveResults from "../common/live-search/LiveResults";
import TopLive from "../common/right-sidebar/TopLive";
import { showLiveSectionOnly } from "../showLiveSectionOnly";

export default function LiveWrapper() {
    const liveData = useLiveData();

    if (liveData == null) {
        return null;
    }

    return (
        <div className="c_8">
            <LeftSidebar>
                <LiveResults />
                {/* <TopCompetitions /> */}
                <CollapseMenu title={getLabel('general.sports')} info={liveData.nel}>
                    <SidebarLink href={`${livePrefix}/favorites`} icon={'Favs_default.svg'} text={getLabel('general.favorites')} />
                    <SidebarLink href={livePrefix} icon={'icon_allsports.svg'} text={getLabel('general.all_sports')} info={liveData.sport.length} />
                    {!showLiveSectionOnly() &&
                        <SidebarLink href={`${prematchPrefix}/daily-flash-odds`} icon={'daily_flash_odds.svg'} text={getLabel('daily_flash_odds')} />
                    }
                    <Menu sports={liveData.sport} />
                </CollapseMenu>
            </LeftSidebar>
            <ErrorBoundary fallback={<ErrorMessageWithLink />}>
                <Outlet />
            </ErrorBoundary>
            <RightSidebar>
                <TopLive />
            </RightSidebar>
        </div>
    );
}
